import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const addAttachemnt = async ({ transportId, file }) => {
  const formData = new FormData();
  formData.append('file', file);

  return request.post(
    `/HousingStock/transport/${transportId}/attachments`,
    formData,
    `При загрузке файла ${file.name} произошла ошибка`,
    'Error'
  );
};

const useAddAttachment = () => {
  return useMutation(addAttachemnt, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });
};

export default useAddAttachment;
